import React from 'react';
import ReactDOM from 'react-dom/client';
import FiveDayPlanner from './FiveDayPlanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FiveDayPlanner />
  </React.StrictMode>
);
